// extracted by mini-css-extract-plugin
module.exports = {"container":"Support_container__2fPLs","content":"Support_content__3idQQ","dropdown":"Support_dropdown__3bTDb"};